<template>
<v-card>
  <v-card-title>
    Mass Edit Items

  <div class="flex-grow-1"></div>

  <v-btn icon @click="closeEdit">
    <v-icon>mdi-close</v-icon>
  </v-btn>
  </v-card-title>
  <v-card-text>
    <v-row>
      <v-col>
        The following items will get edited:<br>
        <span v-for="(val, index) in propItems" :key="val.id">
          <span class="font-weight-bold">{{ val.serialNumber }}</span><span v-if="index !== Object.keys(propItems).length -1">, </span>
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field v-model="customerNameSearch" label="Customer" append-icon="mdi-magnify" @click:append="searchForCustomer" @keyup.enter="searchForCustomer"></v-text-field>

        <v-data-table
        v-if="(customers && customers.length > 0)"
        :headers="customersHeaders"
        :items="customers"
        class="elevation-1"
        @click:row="rowClicked">
        </v-data-table>

        <v-select :items="locations" v-model="selectedLocationId" label="Location" item-text="name" item-value="id"></v-select>
        <v-select :items="iothubs" v-model="selectedIothub" label="IoTHUB" item-text="friendlyName" item-value="iothub"></v-select>

        <v-textarea v-model="patchNotes" label="Notes"></v-textarea>

        <v-select
          v-model="selectedTags"
          :items="logTags"
          item-text="name"
          item-value="name"
          multiple>
          <template v-slot:append-item>
            <v-divider class="mb-2"></v-divider>

            <v-list-item>
              <v-text-field label="Add new tag" append-icon="mdi-plus" @click:append="addNewTag" v-model="newTag"></v-text-field>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row v-if="errorMessage">
      <v-col>
        {{ errorMessage }}
      </v-col>
    </v-row>

    <v-row>
      <div class="flex-grow-1"></div>

      <v-col class="text-right">
        <v-btn class="mr-3" color="success" @click="saveChanges" :loading="loading">
          Save
        </v-btn>
        <v-btn @click="closeEdit" :disabled="loading">
          Cancel
        </v-btn>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>

</template>

<script>
import axios from 'axios'

export default {
  name: 'MassEditItems',

  props: ['propItems'],

  data: () => ({
    customerNameSearch: '',
    selectedCustomer: null,
    selectedLocationId: null,
    selectedIothub: null,
    patchNotes: '',
    selectedTags: [],
    newTag: '',
    loading: false,
    errorMessage: '',
    customersHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' }
    ]
  }),

  methods: {
    closeEdit () {
      console.log('closeEdit triggered')
      this.$emit('editMode')
      this.$store.commit('setCustomers', [])
      this.errorMessage = ''
      this.loading = false
    },

    addNewTag () {
      this.selectedTags.push(this.newTag)
      this.logTags.push(this.newTag)
      this.newTag = ''
    },

    searchForCustomer () {
      console.log('searchForCustomer triggered')

      this.$store.dispatch('getCustomersByFilter', this.customerNameSearch)
    },

    rowClicked (customer) {
      console.log('rowClicked customer.id:', customer.id)

      this.selectedCustomer = customer
      this.customerNameSearch = customer.name
      this.$store.commit('setCustomers', [])
    },

    async saveChanges () {
      console.log('saveChanges triggered')

      this.loading = true

      const payload = {
        customerId: this.selectedCustomer ? this.selectedCustomer.id : undefined,
        locationId: this.selectedLocationId,
        iothub: this.selectedIothub,
        notes: this.patchNotes,
        tags: this.selectedTags
      }

      for (let i = 0; i < this.propItems.length; i++) {
        try {
          await axios.patch(process.env.VUE_APP_API_URL + '/item/' + this.propItems[i].id, payload)
          this.loading = false
        } catch (err) {
          console.error('Error trying to saveChanges axios.patch()', err)
          this.errorMessage = err
          this.loading = false
        }
      }
      this.closeEdit()
    }
  },

  computed: {
    locations () {
      return this.$store.state.locations
    },

    iothubs () {
      return this.$store.state.iothubs
    },

    customers () {
      return this.$store.state.customers
    },

    logTags () {
      return this.$store.state.logTags
    }
  }
}
</script>
